module.exports = "<app-header *ngIf=\"!isLogin\"></app-header>\r\n<app-main [isLogin]='isLogin' class='{{ materialTheme }}'>\r\n    <app-menu *ngIf=\"!isLogin\"></app-menu>\r\n            <div class=\"main-screen\">\r\n                <router-outlet></router-outlet>\r\n            </div>\r\n</app-main>"


//////////////////
// WEBPACK FOOTER
// C:/www/onetouchSuperAdmin/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 2